import React from 'react';
import { useParams } from 'react-router-dom';

const AthleteModuleWrapper = ({ moduleName, children }) => {
  const { athleteId } = useParams();
  return children({ athleteId: athleteId || null, moduleName });
};

export default AthleteModuleWrapper;
